import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Image } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import JsBarcode from "jsbarcode";
import { formatFloat } from "../../_App/Helpers/helpers";
import { useAppSelector } from "../../_App/Redux/hooks";
import { SelectedOrganisation } from "../../_App/Redux/Slices/Auth/authSlice";

export default function TicketArticle({
  ShowModal,
  setShowModal,
  tickets,
  t,
  stateQte,
  impression,
}: any) {
  const organisation = useAppSelector(SelectedOrganisation);
  const componentRef = useRef(null);
  const [list, setlist] = useState(tickets);
  const [qtearticle, setqtearticle] = useState<number>(0);

  useEffect(() => {
    if (qtearticle !== 0) {
      const newtickets = tickets.map((item: any) => {
        return { ...item, qte: qtearticle };
      });
      setlist(newtickets);
    } else {
      setlist(tickets);
    }
  }, [tickets, qtearticle]);
  const generateBarcode = (code_a_barre: any) => {
    // Create a canvas element to render the barcode
    const canvas = document.createElement("canvas");

    JsBarcode(canvas, code_a_barre, {
      format: "CODE128",
      width: 5,
      height: 100,
      displayValue: true,
      fontSize: 50,
    });
    return canvas.toDataURL("image/png"); // Return the barcode as a data URL
  };
  const generateBarcodeC1M1 = (code_a_barre: any) => {
    // Create a canvas element to render the barcode
    const canvas = document.createElement("canvas");

    JsBarcode(canvas, code_a_barre, {
      format: "CODE128",
      width: 3,
      height: 100,
      displayValue: true,
      fontSize: 30,
    });
    return canvas.toDataURL("image/png"); // Return the barcode as a data URL
  };
  const generateBarcodeC2M1 = (code_a_barre: string) => {
    if (!code_a_barre) return "";

    const canvas = document.createElement("canvas");

    JsBarcode(canvas, code_a_barre, {
      format: "CODE128",
      width: 1, // Barre la plus fine pour que ça rentre dans 100px
      height: 40, // Hauteur réduite mais suffisante pour le laser
      displayValue: true,
      fontSize: 14, // Texte petit pour ne pas élargir l'image
      background: "#ffffff",
      lineColor: "#000000",
      margin: 5, // Marge minimale (Quiet Zone) indispensable
      textMargin: 2,
    });

    return canvas.toDataURL("image/png");
  };
  const [model, setmodel] = useState("m2");

  return (
    <Modal
      show={ShowModal}
      dialogClassName="modal-90w"
      className="modal-9"
      backdropClassName="modal-backdrop-9"
    >
      <Modal.Header>
        <span onClick={()=>setShowModal(false)}>x</span>
      </Modal.Header>
      <Modal.Body>
        {model === "m1" ? (
          <div ref={componentRef}>
            {(() => {
              const allTickets = list.flatMap((ticket: any, index: number) =>
                Array.from({ length: ticket.qte }, (_, i: number) => ({
                  ...ticket,
                  key: `${index}_${i}`,
                })),
              );

              const pages: any[][] = [];
              for (let i = 0; i < allTickets.length; i += 40) {
                pages.push(allTickets.slice(i, i + 40));
              }

              return pages.map((pageTickets, pageIndex) => (
                <div className="print-content-p" key={pageIndex}>
                  {pageTickets.map((ticket: any) => (
                    <div className="ticket-p" key={ticket.key}>
                      <div className="ticketcontenu-p">
                        <div>
                          {t("Réf")}:{" "}
                          <strong style={{ fontWeight: "bolder" }}>
                            {ticket?.ref?.split("-")[0]}
                          </strong>
                        </div>
                        <div>
                          M: <strong>{ticket?.marque}</strong>
                        </div>
                        <div>
                          {t("Taille")}:{" "}
                          <strong>
                            {ticket?.taille
                              ? ticket?.taille
                              : ticket?.titre?.split(" ")[2]}
                          </strong>
                        </div>
                        <div>
                          {t("Coul")}:{" "}
                          <strong>
                            {ticket?.couleur
                              ? ticket?.couleur
                              : ticket?.titre?.split(" ")[3]}
                          </strong>
                        </div>
                        <div>
                          {t("F")}: {ticket?.famille}
                        </div>

                        {ticket.solde !== null && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                backgroundColor: "red",
                                color: "white",
                                fontSize: "15px",
                                fontWeight: "bold",
                                lineHeight: "50px",
                              }}
                            >
                              {ticket.solde}%
                            </div>

                            <div className="row">
                              <strong
                                style={{
                                  color: "red",
                                  margin: 0,
                                  fontSize: "12px",
                                }}
                              >
                                {formatFloat(
                                  ticket.prix.toFixed(3) *
                                    ((100 - ticket.solde) / 100),
                                )}{" "}
                                {organisation?.currency}
                              </strong>
                            </div>
                          </div>
                        )}

                        <div style={{ fontSize: "10px" }}>
                          {ticket?.coderecption}
                        </div>
                        {ticket?.code_a_barre.startsWith("A") ? (
                          <div>
                            {" "}
                            {/* Conteneur qui définit votre espace */}
                            <img
                              src={generateBarcodeC2M1(ticket?.code_a_barre)}
                              alt="Barcode"
                              style={{
                                width: "130px", // J'ai augmenté à 120px car 100px est risqué pour CODE128
                                height: "auto",
                                imageRendering: "pixelated", // INDISPENSABLE : Garde les barres nettes (pas de flou)
                                display: "block",
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            <img
                              style={{ width: "100px" }}
                              src={generateBarcodeC1M1(ticket?.code_a_barre)}
                              alt="Barcode"
                            />
                          </div>
                        )}

                        <div>
                          {t("Prix")}:{" "}
                          <strong
                            style={{ fontWeight: "bolder" }}
                            className={ticket.solde !== null ? "baree" : ""}
                          >
                            {formatFloat(ticket?.prix?.toFixed(3))}{" "}
                          </strong>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ));
            })()}
          </div>
        ) : (
          <div ref={componentRef} className="print-content">
            {tickets.map((ticket: any, index: number) =>
              Array.from(
                { length: qtearticle || ticket.qte || 1 },
                (_, i: number) => (
                  <div className="ticket" key={index + "_" + i}>
                    <div className="ticketcontenu">
                      {/* Réf centrée */}
                      <div className="centered-text">
                        {t("Réf")}:{" "}
                        <strong
                          style={{ fontWeight: "bold", fontSize: "25px" }}
                        >
                          {ticket?.ref?.split("-")[0]}
                        </strong>
                      </div>

                      {/* Marque centrée */}
                      <div
                        className="centered-text"
                        style={{ fontSize: "15px" }}
                      >
                        <span>M: {ticket?.marque}</span>
                      </div>

                      <div
                        className="centered-text"
                        style={{ fontWeight: "bold", fontSize: "15px" }}
                      >
                        {t("Taille")}:{" "}
                        {ticket?.taille
                          ? ticket?.taille
                          : ticket?.titre?.split(" ")[2]}
                      </div>
                      <div
                        className="centered-text"
                        style={{ fontWeight: "bold", fontSize: "15px" }}
                      >
                        {t("Coul")}:{" "}
                        {ticket?.couleur
                          ? ticket?.couleur.libelle || ticket?.couleur
                          : ticket?.titre?.split(" ")[3]}
                      </div>
                      <div
                        className="centered-text"
                        style={{ fontSize: "15px" }}
                      >
                        <span>F: {ticket?.famille}</span>
                      </div>
                      {ticket?.coderecption && (
                        <div style={{ fontSize: "15px" }}>
                          {t("Ref")}: {ticket?.coderecption}
                        </div>
                      )}
                      <div className="centered-text">
                        <img
                          style={{ width: "150px", height: "80px" }}
                          src={generateBarcode(ticket?.code_a_barre)}
                          alt="Barcode"
                        />
                      </div>

                      <div>
                        {ticket.solde !== null ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                backgroundColor: "red",
                                color: "white",
                                fontSize: "15px",
                                fontWeight: "bold",
                                lineHeight: "50px",
                              }}
                            >
                              {ticket.solde}%
                            </div>

                            <div className="row">
                              <strong
                                style={{
                                  color: "red",
                                  margin: 0,
                                  fontSize: "16px",
                                }}
                              >
                                {formatFloat(
                                  ticket.prix.toFixed(3) *
                                    ((100 - ticket.solde) / 100),
                                )}{" "}
                                {organisation?.currency}
                              </strong>
                              <p className="baree">
                                {formatFloat(ticket.prix.toFixed(3))}
                              </p>
                            </div>
                          </div>
                        ) : (
                          <>
                            <strong style={{ fontSize: "30px" }}>
                              Prix
                              {formatFloat(ticket?.prix?.toFixed(3))}
                            </strong>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ),
              ),
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="row">
        {impression && (
          <>
            <ReactToPrint
              trigger={() => (
                <Button className="col-6" variant="primary">
                  Imprimer
                </Button>
              )}
              content={() => componentRef.current}
            />
            <div className="col-2">
              {" "}
              <input
                type="radio"
                onClick={() => setmodel("m1")}
                checked={model === "m1"}
              />{" "}
              {t("model1")}
              <input
                type="radio"
                onClick={() => setmodel("m2")}
                checked={model === "m2"}
              />{" "}
              {t("model2")}
            </div>
            {stateQte && (
              <>
                <div className="col-1"> Qte ticket</div>
                <div className="col-2">
                  <input
                    type="number"
                    className="form-control "
                    value={qtearticle}
                    onChange={(e) =>
                      setqtearticle(parseInt(e.target.value) || 0)
                    }
                  />
                </div>
              </>
            )}
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
}
